export * from './statistic-page'
